/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, css, Grid, HStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from '../../hooks/use-is-mobile';
import useDebounce from '../../hooks/use-debounce';
import { useTheme } from '../../contexts/ThemeProvider';
import { useProfile } from '@/contexts/ProfileProvider';
import { useActivities } from '@/service/club/hooks';
import { Activity } from './Activity';

export function ActivityGrid({ column = false, search = '' }: { column?: boolean; search?: string }) {
  const searchDebounce = useDebounce(search, 500);
  const { profile } = useProfile();
  const { openModalLogin } = useTheme();

  const nav = useNavigate();
  const { data: activities = new Array(6).fill(null) } = useActivities();

  const isMobile = useIsMobile();

  const onPress = (categories: any) => {
    if (!profile) {
      openModalLogin();
      return;
    }

    nav('/vantagens', {
      state: categories,
    });
  };

  if (isMobile && !column) {
    return (
      <Box
        overflowX="auto"
        whiteSpace="nowrap"
        width={'100%'}
        paddingLeft={'20px'}
        css={css({
          scrollbarWidth: 'none',
          '::-webkit-scrollbar': { display: 'none' },
          WebkitOverflowScrolling: 'touch',
          border: 'none',
        })}
      >
        <HStack spacing={4} display="flex" minWidth="fit-content">
          {activities?.map((a, index) => {
            return (
              <Box
                key={index}
                minWidth="165px"
                maxWidth="165px"
                flexShrink={0}
                paddingRight={index === activities.length - 1 ? '20px' : '0'}
              >
                <button onClick={() => onPress(a?.categories)} style={{ all: 'unset', cursor: 'pointer' }}>
                  <Activity height={110} centerLabel borderRadius={8} activity={a} />
                </button>
              </Box>
            );
          })}
        </HStack>
      </Box>
    );
  }

  return (
    <Grid
      padding={{
        base: '0px',
        md: '0px 20px',
      }}
      margin={'auto'}
      templateColumns={{ base: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)', lg: 'repeat(6, 1fr)' }}
      gap={4}
    >
      {activities?.map((a, i) => (
        <button key={i} onClick={() => onPress(a?.categories)} style={{ all: 'unset', cursor: 'pointer' }}>
          <Activity fullWidth={isMobile} height={120} centerLabel borderRadius={8} activity={a} />
        </button>
      ))}
    </Grid>
  );
}
